import { render, staticRenderFns } from "./TaxBackLP.vue?vue&type=template&id=032b38b8&scoped=true&"
import script from "./TaxBackLP.vue?vue&type=script&lang=js&"
export * from "./TaxBackLP.vue?vue&type=script&lang=js&"
import style0 from "./TaxBackLP.vue?vue&type=style&index=0&id=032b38b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032b38b8",
  null
  
)

export default component.exports